import React, { FC, memo, Fragment } from 'react'

import { useCurrentSlideIndex } from '../../hooks/carousel'
import { ArrowContainerBack, ArrowLeftIcon } from './tips-section-styles'

const CarouselButtonBack: FC = () => {
    const _currentSlideIndex = useCurrentSlideIndex()

    return _currentSlideIndex !== 0 ? (
        <ArrowContainerBack>
            <ArrowLeftIcon />
        </ArrowContainerBack>
    ) : (
        <Fragment />
    )
}

export default memo(CarouselButtonBack)
